import { usePageLayout } from "./hooks/usePageLayout";

const DyanmicLandingPage = () => {
  const { layout, loading } = usePageLayout();
  if (loading) return <div>Loading...</div>;

  const body = layout.body.match(/<body[^>]*>([\s\S]*?)<\/body>/i)?.[1] ?? layout.body;

  const inlinedHtml = body
  .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
  .replace(/<link[^>]*>/gi, "")
  .replace(/\{\{home-page-url\}\}/g, "/")
  .replace(/\{\{login-page-url\}\}/g, "/login")
  .replace(/\{\{signup-page-url\}\}/g, "/signup")
  .replace(/classname=/gi, "class=");

  return <div dangerouslySetInnerHTML={{ __html: inlinedHtml }} />;
};

export default DyanmicLandingPage;